import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {RootState} from '@app/store/root-state';
import {Observable} from 'rxjs';
import {filter} from 'rxjs/operators';
import {RaceClass} from '@app/rest-client/faxe/models/race-class';
import { selectRaceClassByRaceGuid } from '@app/store/faxe/race-class/race-class.selectos';
import { isNotEmpty } from '@app/fremework/functions';
import { fetchRaceClasses } from '@app/store/faxe/race-class/race-class.actions';

@Injectable({
  providedIn: 'root'
})
export class RaceClassFacadeService {

  constructor(private store: Store<RootState>) {
  }

  fetchRaceClass(raceGuid: string, issuer: string): Observable<RaceClass[]> {
    this.store.dispatch(
      fetchRaceClasses(
        {raceGuid, issuerStack: [issuer]}));

    return this.store.pipe(
      select(selectRaceClassByRaceGuid(raceGuid)),
      filter((data) => isNotEmpty(data)));
  }

}
